An array of up to 25 profiles for the position opening.

Each profile represents a posted job ad or an unposted internal requisition associated with this opening.
